// removed by extract-text-webpack-plugin
module.exports = {"container":"Confirmation__container___2dFFY"};